<template>
  <div class="page-table scrollable only-y mainDiv mb-30">
    <div class="card-base baslikBg animated fadeInUp">Log Listesi
      <div class="tanimlamaButon">
        <el-tooltip :content='$t("src.views.apps.genel.refresh")' :open-delay="500" placement="top">
          <el-button v-on:click="refreshPage()" style="margin-left: 15px !important" type="text"
                     icon="el-icon-refresh"></el-button>
        </el-tooltip>
      </div>
    </div>
    <div class="page-header card-base card-shadow--medium animated fadeInUp" v-loading="loading || stateLoading"
         :element-loading-text='loading ? "Log Listesi Getiriliyor Lütfen Bekleyiniz" : "Log Güncelleniyor. Lütfen Bekleyiniz."'
         element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 1)">
      <el-row class="mt-0 mb-10">
        <el-col :lg="12" :md="12" :sm="24" :xs="24">
          <div>
            <el-radio-group size="small" v-on:change="handleChange($event)" v-model="radio" fill="#E5F5F9"
                            text-color="gray" :disabled="searchLoading">
              <el-radio-button label="1">
                <i class="mdi mdi-account mdi-18px" style="color: #ec205f; margin-right: 5px"></i>
                <transition name="slide-fade">
                  <label v-if="durum == '1'">Silinenler</label>
                </transition>
              </el-radio-button>
              <el-radio-button label="2">
                <i class="mdi mdi-account mdi-18px" style="color: orange; margin-right: 5px"></i>
                <transition name="slide-fade">
                  <label v-if="durum == '2'">Güncellenenler</label>
                </transition>
              </el-radio-button>
            </el-radio-group>
          </div>
        </el-col>
        <br v-if="!isDesktop">
        <br v-if="!isDesktop">
      </el-row>
      <div class="my-custom-table">
        <el-table v-loading="searchLoading" border stripe :data="logList"
                  style="width: 100%" :element-loading-text='"Loglar Aranıyor. Lütfen Bekleyiniz."'
                  element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 1)">
          <el-table-column prop="olusturanID" label="İşlem Sahibi ID"/>
          <el-table-column label='Silinen Dosya' prop="veri" width="auto">
            <template slot-scope="prop">
              <el-image @click="downloadFile(prop.row)"
                        :src="logService.variablePath + prop.row.yol"
                        style="width: 100px; height: 100px;cursor: pointer"/>
            </template>
          </el-table-column>
          <el-table-column prop="olusturan" label="İşlemi Gerçekleştiren"/>
          <el-table-column prop="olusumTarihi" label="İşlem Tarihi"/>
          <el-table-column prop="ip1" label="IP"/>
        </el-table>
      </div>
      <el-pagination background layout="sizes,prev, pager, next, jumper, total" :total="total"
                     @size-change="handleSizeChange" @current-change="pageChange" :page-sizes="[20, 50, 100]"
                     :current-page.sync="page" :next-click.sync="page" :prev-click.sync="page" @next-click="pageChange"
                     @prev-click="pageChange">
      </el-pagination>
    </div>
    <el-dialog title="Talimat Detay" :visible.sync="dialogVisible" width="50%">
      <div>
        <ckeditor :disabled="true" :editor="editor" :config="editorConfig" v-model="editorData"/>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CKeditor from '@ckeditor/ckeditor5-build-classic/build/ckeditor'
import musteriService from '../../../WSProvider/MusteriService'
import EventBus from '@/components/event-bus'
import notification from '../../../notification'
import functions from '../../../functions'
import logService from "@/WSProvider/LogService";

var moment = require('moment');

export default {
  name: "Loglar",
  computed: {
    logService() {
      return logService
    },
  },
  components: {},
  data() {
    return {
      dekontListMain: [],
      dekontForm: {
        evrakTarihi: "",
        durum: '1',
        cariID: "",
        evrak: [],
        evrakID: '',
        evrakAdi: ''
      },
      editorData: '',
      editor: CKeditor,
      editorConfig: {
        language: 'tr',
      },
      dialogVisible: false,
      isDesktop: false,
      loading: false,
      stateLoading: false,
      searchLoading: false,
      //editDialogLoading: false,
      editDialog: false,
      editDialogData: {},
      logList: [],
      yetkiListesi: [],
      tarihler: [],
      yetkiTuru: "",
      yoneticiID: "",
      radio: '1',
      rulesMusteri: {},
      sizes: 20,
      durum: '1',
      page: 0,
      postPage: 0,
      total: 4,
      firmaAdiAra: "",
      unvanAra: "",
      adresAra: "",
      telefonAra: "",
      epostaAra: "",
    }
  },
  created() {
    this.checkDevice();
    if (localStorage.getItem("userDataDemirag")) {
      this.yetkiTuru = this.$store.getters.getYetkiTuru;
      this.yetkiListesi = this.$store.getters.getYetkiListesi;
      this.yoneticiID = this.$store.getters.getYoneticiID;
      //console.log(this.yetkiListesi)
    }
    EventBus.$on("logListesi", (durum) => {
      this.refreshPage(durum ? 1 : 0)
    });
  },
  mounted() {
    this.getLoglar();
    window.addEventListener('resize', this.checkDevice);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkDevice);
  },
  methods: {
    evrakRemove() {
      $('#evrakEkle .el-upload--belge-card').show();
      this.dekontListMain = [];
      this.dekontForm.evrak = [];
    },
    downloadFile(item) {
      var downloadLink = document.createElement("a");
      downloadLink.href = logService.variablePath + item.yol;
      downloadLink.download = item.yol;
      downloadLink.target = "_blank";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    },
    checkDevice() {
      this.isDesktop = window.innerWidth >= 768;
    },
    updatePage(data) {
      this.$store.commit('changeMusteriUpdateData', data.muhasebeID)
      functions.routeSayfa("Talimat Güncelle", this)
    },
    talimatAra() {
      this.postPage = 0;
      this.page = 1
      this.dateVisible = false;
      //siparisNo, adSoyad, telefon, country, city, state, baslangicTarihi, bitisTarihi, durum, baslangic, limit,
      if (this.firmaAdiAra.length > 0 || this.unvanAra.length > 0 || this.adresAra.length > 0 || this.telefonAra.length > 0 || this.epostaAra.length > 0) {
        try {
          this.searchLoading = true;
          //kullaniciAdi, adSoyad, mail, telefon, durum, baslangic, limit)
          musteriService.musteriFilter(this.firmaAdiAra, this.unvanAra, this.adresAra, this.telefonAra, this.epostaAra, this.durum, this.postPage, this.sizes).then(response => {
            if (response.status == 200) {
              this.logList = response.data;
              this.total = response.count
            }
            localStorage.setItem("userDataDemirag", response.token);
            this.searchLoading = false;
          }).catch(err => {
            if (err.responseJSON) {
              let error = err.responseJSON
              if (error.status == 401) {
                notification.Status(150, this);
              } else if (error.status == 404) {
                this.logList = []
              }
            } else {
              //notification.Status(503, this)
            }
            this.searchLoading = false;
          })
        } catch (e) {
          // notification.Status("danger", this, "An error occurred during the customer search process.")
          this.searchLoading = false
        }
      } else {
        this.getLoglar();
        // this.getMusteriSayisi();
      }
    },
    refreshPage(durum) {
      this.page = 1;
      this.postPage = 0;
      this.loading = false;
      this.stateLoading = false;

      // this.getMusteriSayisi();
      this.getLoglar(durum);
    },
    vazgec(formName) {
      this.$refs[formName].resetFields();
      this.editDialog = false;
      this.loading = false;
      this.stateLoading = false;
    },
    getLoglar(durum) {
      const logInYetkiler = this.$store.state.yetkiListesi;
      try {
        if (durum) this.durum = durum
        this.loading = true;
        logService.silinenLoglar(this.durum, this.postPage, this.sizes).then((response) => {
          localStorage.setItem("userDataDemirag", response.token)
          if (response.status == 200) {
            this.logList = response.data;
            this.total = parseInt(response.toplamKayit);
          }
          this.loading = false;

        }).catch(err => {
          console.log(err);
          if (err.responseJSON) {
            let error = err.responseJSON
            if (error.status == 401) {
              notification.Status(150, this);
            } else if (error.status == 404) {
              this.logList = [];
            } else notification.Status("errorMsg", this, error.errMsg)
          } else {
            //notification.Status(503, this)
          }
          this.loading = false;
        })
      } catch (e) {
        // notification.Status("success", this, "An error occurred while fetching the customer list.")
        this.loading = false
      }
    },
    routeMusteri(name, scope) {
      if (scope) {
        this.$store.commit('changeMusteriUpdateData', scope);
      }
      functions.routeSayfa(name, this);
    },
    indexMethod(index) {
      return ((this.page - 1) * this.sizes) + index + 1;
    },
    handleSizeChange(val) {
      this.sizes = val;
      this.getLoglar();
    },
    handleChange(event) {
      this.durum = event;
      this.page = 1;
      this.postPage = 0;
      this.getLoglar();
      document.querySelector('.scrollable').scrollTo({top: 0, behavior: 'smooth'});
      this.firmaAdiAra = ""
      this.unvanAra = ""
      this.adresAra = ""
      this.telefonAra = ""
      this.epostaAra = ""
    },
    pageChange(val) {
      this.postPage = (val - 1) * this.sizes;
      this.getLoglar();
    },
  }
}

function getDays(tarih1, tarih2) {
  // Tarihleri Moment objelerine dönüştür ve gün farkını hesapla
  const tarih1Moment = moment(tarih1);
  const tarih2Moment = moment(tarih2);
  const gunFarki = tarih2Moment.diff(tarih1Moment, 'days');

  // Sonucu döndür
  return gunFarki;
}

function sozlesmeBittiMi(tarih1, tarih2) {
  // Tarihleri Moment objelerine dönüştür
  const momentTarih1 = moment(tarih1);
  const momentTarih2 = moment(tarih2);

  // Tarih1 tarih2'den sonra mı?
  return momentTarih1.isAfter(momentTarih2);
}

function projeBasladiMi(bugun, baslangicTarihi) {
  const momentBugun = moment(bugun)
  const momentBaslangic = moment(baslangicTarihi)

  return momentBugun.isAfter(momentBaslangic)
}

function getMonthsBetween(start, end) {

  moment.locale('tr');
  const results = [];

  for (let m = moment(start); m.isSameOrBefore(end, 'month'); m.add(1, 'months')) { //for (let m = moment(start); m.isBefore(end); m.add(1, 'months')) {
    const monthStart = moment(m).startOf('month');
    const monthEnd = moment(m).endOf('month');

    let daysInMonth = monthEnd.diff(monthStart, 'days') + 1 //ayın günlerinikaç gün olduğunu hesaplıyor

    if (m.isSame(moment(start).startOf('month'), 'month')) {
      daysInMonth -= moment(start).date();
    }
    if (m.isSame(moment(end).endOf('month'), 'month')) {
      daysInMonth -= monthEnd.date() - moment(end).date();
    }

    results.push({
      month: monthStart.format('MMMM'),
      monthIndex: parseInt(monthStart.month()) + 1,
      days: daysInMonth   //- 1
    });
  }
  return results;
}

function checkDateRange(start, end) {
  const today = moment();
  if (today.isBefore(start, 'day')) {
    return 0;
  } else if (today.isBetween(start, end, 'day')) {
    return 1;
  } else {
    return 2;
  }
}
</script>

<style lang="scss">
.el-table .info-row {
  background: rgba(125, 199, 225, 0.45);
}

.el-table .error-row {
  background: rgba(249, 0, 26, 0.08);
}

.el-table .success-row {
  background: rgba(3, 249, 0, 0.08);
}

.el-table .warning-row {
  background: rgba(245, 249, 0, 0.08);
}
</style>
<style lang="scss" scoped>
.refresh {
  color: #fff;
  float: right;
  padding: 0 !important;
  transition: all 0.5s;

}

.refresh:hover {
  transform: rotate(360deg);
}

.el-pagination {
  margin-top: 20px;
  float: right;
}

.el-radio-button--mini .el-radio-button__inner label {
  position: relative;
  bottom: 5px;
}

.kaldirilmis {
  background: #ec205f;
  color: white;
  font-weight: bold;
  font-size: 16px;
  padding: 10px
}
</style>
<style lang="scss">
.slide-fade-enter-active {
  transition: all .3s ease;
}


@media (min-width: 768px) {
  .el-radio-button--mini .el-radio-button__inner {
    padding: 0 10px !important;
    font-size: 11px;
    border-radius: 0;
  }
}


.slide-fade-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter,
.slide-fade-leave-to

  /* .slide-fade-leave-active below version 2.1.8 */
{
  transform: translateX(10px);
  opacity: 0;
}
</style>
<style>
/*
    .tablo{
        background-color: rgb(59, 123, 179); /*rgb(148, 197, 240);
    }*/

.tablo th.el-table__cell > .cell {
  background-color: aliceblue;
}


.islem-button {
  padding-top: 1px;
  padding-bottom: 1px;
  margin-top: 1px;
  margin-bottom: 1px;
  font-size: 0;
  line-height: 1;
  /* Butonun içeriği ile yükseklik arasındaki mesafeyi sıfırlar */
}

.buttonDel {
  padding-top: 1px;
  padding-bottom: 1px;
  margin-top: 1px;
  margin-bottom: 1px;
  font-size: 0;
  line-height: 1;
  /* Butonun içeriği ile yükseklik arasındaki mesafeyi sıfırlar */
}

.el-table .cell {
  line-height: 17px !important;
}

.el-table thead {
  line-height: 30px !important;
}
</style>